import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ProfileAvatar } from 'src/components/avatar/profile-avatar';
import { ReactComponent as BackArrow } from 'src/assets/icons-redesign/back-arrow.svg';
import ProfileMenu from 'src/components/profileMenu/profileMenu';
import { signOut } from 'src/redux/user/user.async-thunks';
import { RootState } from 'src/redux/redux-store';
import '../template.css';

interface DashboardMenubarProps {
  readonly bgColorClass?: string;
  readonly imageUrl?: string;
  readonly hideBack?: boolean;
}

export const DashboardMenubar = ({ bgColorClass = '', imageUrl, hideBack = false }: DashboardMenubarProps) => {
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { search } = useLocation();
  const userState = useSelector((state: RootState) => state.userState);
  const isClient = userState.permissions?.groups?.includes('client_user') || userState.permissions?.groups?.includes('client_admin');

  const handleAvatarClick = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleProfileClick = () => {
    const accountPath = search.includes('404=t') ? '/account?404=t' : '/account';
    navigate(accountPath);
  };

  const handleLogoutClick = async() => {
    await dispatch(signOut() as any);
    navigate('/login');
  };

  useEffect(() => {
    const handler = (e: any) => {
      if (!menuRef.current?.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
  });

  return (
    <div className={`left-0 top-0 flex w-full items-center justify-between p-4 ${bgColorClass}`}>
      <div className="flex items-center">
        {!hideBack && (
          <div
            className='bg-white rounded-full shadow-md p-2 cursor-pointer'
            onClick={() => navigate(-1)}
          >
            <BackArrow className="size-[18px]" />
          </div>
        )}
      </div>
      <div
        className="flex items-center"
        ref={menuRef}
      >
        <ProfileAvatar
          imgSrc={imageUrl}
          onClick={handleAvatarClick}
        />
        <div className="relative" >
          {isMenuOpen && (
            <ProfileMenu
              onProfileClick={handleProfileClick}
              onLogoutClick={handleLogoutClick}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const connector = connect(null, { signOut });

export default connector(DashboardMenubar);
